/** Only explicit campaign fields and URL paths; never store arbitrary query strings or contact data. */
export function headphoneSource() {
  const params = new URLSearchParams(window.location.search);
  const cleanUrl = (raw: string) => { try { const u = new URL(raw); return (u.origin + u.pathname).slice(0, 500); } catch { return ""; } };
  const current = { path: window.location.pathname.slice(0, 500), referrer: cleanUrl(document.referrer),
    utm_source: (params.get("utm_source") || "").slice(0, 120), utm_medium: (params.get("utm_medium") || "").slice(0, 120),
    utm_campaign: (params.get("utm_campaign") || "").slice(0, 120), utm_content: (params.get("utm_content") || "").slice(0, 120), utm_term: (params.get("utm_term") || "").slice(0, 120) };
  try {
    const saved = JSON.parse(sessionStorage.getItem("headphone-source") || "null");
    if (!params.has("utm_source") && saved && Object.keys(current).every(key => typeof saved[key] === "string")) return saved as typeof current;
    sessionStorage.setItem("headphone-source", JSON.stringify(current));
  } catch { /* Optional attribution storage must not prevent shopping. */ }
  return current;
}
